import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

export const PixiePreset = definePreset(Aura, {
  options: {
    darkModeSelector: false,
  },
  semantic: {
    primary: {
      50: '#f5effd',
      100: '#eaddfb',
      200: '#d3bbf7',
      300: '#b792f0',
      400: '#9d69e4',
      500: '#640DAF',
      600: '#580b9c',
      700: '#480983',
      800: '#390769',
      900: '#2b0650',
      950: '#1d0437'
    }
  },

});
